import { render, staticRenderFns } from "./Blocks.vue?vue&type=template&id=51610868&"
import script from "./Blocks.vue?vue&type=script&lang=js&"
export * from "./Blocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports